import React from 'react';
import styled from '@emotion/styled';
import { RichImage } from 'data/global/types';

type ImgProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export type ImageQueryParams = {
  fm?: 'jpg' | 'png' | 'webp';
  fl?: 'progressive' | 'png8';
  fit?: 'pad' | 'fill' | 'scale' | 'crop' | 'thumb';
  w?: string;
  h?: string;
  r?: string;
  q?: string;
  bg?: string;
  f?:
    | 'center'
    | 'top'
    | 'right'
    | 'left'
    | 'bottom'
    | 'top_right'
    | 'top_left'
    | 'bottom_right'
    | 'bottom_left'
    | 'face'
    | 'faces';
};

export type RichImageComponentProps = {
  image: RichImage;
  queryParams?: ImageQueryParams;
} & Omit<ImgProps, 'ref'>;

const contentfulBaseApiUrl = 'https://images.ctfassets.net';

export const RichImageComponent: React.FC<RichImageComponentProps> = ({
  image: { url, alt, maxWidth },
  queryParams,
  ...otherProps
}) => {
  const isContenfulImage = url.includes(contentfulBaseApiUrl);
  const urlParams =
    queryParams && isContenfulImage
      ? '?' +
        new URLSearchParams(queryParams as Record<string, string>).toString()
      : '';
  const imgProps = {
    alt,
    src: url + urlParams,
    maxWidth,
    ...otherProps,
  };

  return <MaxWidthImage {...imgProps} />;
};

const MaxWidthImage = styled.img`
  max-width: ${({ maxWidth }: { maxWidth: number | null }) =>
    maxWidth ? maxWidth + 'px !important' : null};
  margin: ${({ maxWidth }: { maxWidth: number | null }) =>
    maxWidth ? '0 auto' : null};
`;
